"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _packageInfo = require("@polkadot/networks/cjs/packageInfo");
var _packageInfo2 = require("@polkadot/util/cjs/packageInfo");
var _xRandomvalues = require("@polkadot/x-randomvalues");
// Copyright 2017-2023 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
var _default = [_packageInfo.packageInfo, _packageInfo2.packageInfo, _xRandomvalues.packageInfo];
exports.default = _default;